let _appEnv = {};

if (typeof window !== 'undefined') {
    _appEnv = window.__APP_ENVIRONMENT__ || {};
}

const setEnvironment = (env) => {
    for (const key in env) {
        if (key) {
            _appEnv[key] = env[key];
        }
    }
};

const getVar = (key) => {
    let value = _appEnv[key];

    if (typeof window !== 'undefined') {
        if (window.location.search) {
            const search = window.location.search;
            const match = search.match(`[?&]${key}=([a-zA-Z-_0-9.]+)`);

            if (match && match[1] !== undefined) {
                switch (match[1]) {
                    case 'true':
                        value = true;
                        break;
                    case 'false':
                        value = false;
                        break;
                    default:
                        value = match[1];
                }
            }
        }
    }

    return value;
};
const appEnvironment = {
    getVar,
    setEnvironment,
};

export default appEnvironment;
